import templates from '../../../ui/widgets/resource-entry/templates';
import { buildNoRecordsConfig, getStartDateForData } from './schedule-five-individual-combined-elements';
import { TITLE_WIDTH, TOTAL_WIDTH, registerSummaryGridRefresher } from './schedule-five-summary-shared';

let _k_prevMonthGrid = null;

const createPrevMonthGridInternal = (data, startDate, opts = {}) => {
    const $grid = $('.grid.previous-month-grid');
    _k_prevMonthGrid?.grid?.destroy();
    $grid.empty();

    _k_prevMonthGrid = $grid
        .kendoResourceEntry({
            columnWidth: 120,
            dataSource: {
                schema: {
                    model: {
                        id: 'id',
                        fields: {
                            title: { editable: false, type: 'string' },
                            total: { editable: false, type: 'number' },
                        },
                    },
                },
                data: data,
            },
            staticColumns: [
                {
                    field: 'title',
                    type: 'string',
                    title: '&nbsp;',
                    width: TITLE_WIDTH,
                    editable: false,
                },
                {
                    field: 'total',
                    type: 'number',
                    template: templates.columnBased('total', 'format'),
                    title: 'Total',
                    width: TOTAL_WIDTH,
                    editable: false,
                },
            ],
            readonly: true,
            startDate: startDate,
            input: {
                type: 'columnBased',
                typeColumn: 'format',
            },
            dataBound() {
                $('.grid.previous-month-grid div.k-grid-footer').hide();
            },
            grid: {
                ...buildNoRecordsConfig(opts.suppressNoRecords),
            },
        })
        .data('kendoResourceEntry');
};

export const createPrevMonthGrid = (filters = {}) => {
    const $grid = $('.grid.previous-month-grid');
    const company = $grid.data('company');
    return $.getJSON('/Operations/ScheduleFiveOverview/GetPreviousPeriodRevenueTotals', { company, ...filters }).done(data => {
        const startDate = getStartDateForData(data);
        createPrevMonthGridInternal(data, startDate);
    });
};

export const getPrevMonthGrid = () => _k_prevMonthGrid?.grid;

export const refreshPrevMonthGrid = () => {
    _k_prevMonthGrid.grid.refresh();
};

export const initPrevMonthGrid = () => {
    registerSummaryGridRefresher(createPrevMonthGrid);
    createPrevMonthGridInternal([], new Date(), { suppressNoRecords: true });
    kendo.ui.progress($('.s5-previous-month-wrap'), true);

    return Promise.all([createPrevMonthGrid()])
        .then(() => {
            kendo.ui.progress($('.s5-previous-month-wrap'), false);
        })
        .catch(() => {
            kendo.ui.progress($('.s5-previous-month-wrap'), false);
        });
};
